import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define types for form state
interface FormState {
  name: string;
  Pass: string;
}

// Initial state for the form slice
const initialFormState: FormState = {
  name: "",
  Pass: "",
};

// Form slice
const formSlice = createSlice({
  name: "form",
  initialState: initialFormState,
  reducers: {
    updateForm: (state, action: PayloadAction<Partial<FormState>>) => {
      return { ...state, ...action.payload };
    },
    clearForm: () => initialFormState,
  },
});

// Define types for auth state
interface AuthState {
  username: string | null;
  userid: number | null;
  emailid: string;
  token: string | null;
  isSuccessful: boolean;
  firstname: string | null;
  lastname: string | null;
}

// Initial state for the auth slice
const initialAuthState: AuthState = {
  username: "",
  userid: null,
  emailid: "",
  token: "",
  isSuccessful: false,
  firstname: "",
  lastname: "",
};

// Auth slice
const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    updateAuthForm: (state, action: PayloadAction<Partial<AuthState>>) => {
      return { ...state, ...action.payload };
    },
    clearAuthForm: () => initialAuthState,
  },
});

// Export actions
export const { updateForm, clearForm } = formSlice.actions;
export const { updateAuthForm, clearAuthForm } = authSlice.actions;

// Export reducers
export const formReducer = formSlice.reducer;
export const authReducer = authSlice.reducer;
